import ImgCrop from 'antd-img-crop';
import PropTypes from 'prop-types';
import TranslationsContext from 'providers/translationsProvider';
import { useContext } from 'react';
import addWhiteBackgroundToImage from 'utils/image-background';

/**
 * Returns wrapped children with ImgCrop to crop the uploaded image if `withCrop` prop is true.
 * Otherwise it return its children.
 * Expected children is an Upload component from Antd
 *
 * @param {boolean} props.withCrop - Whether to wrap children with ImgCrop.
 * @param {number} props.aspect - The aspect ratio the image will be cropped with. width/height
 * @param {boolean} props.addWhiteBackground - Whether to add white background to fit aspect ratio
 * @param {ReactNode} props.children - Upload component from Antd.
 * @returns {ReactNode} Rendered component.
 */
const ImageCropWrapper = ({ withCrop = false, aspect = 1, addWhiteBackground = false, children }) => {
  const { t } = useContext(TranslationsContext);

  if (withCrop) {
    const cropProps = {
      aspect,
      modalOk: t('Ok'),
      modalCancel: t('Cancel'),
      modalTitle: t('Edit image'),
      maxZoom: 3.5,
    };

    // Add beforeCrop function to process image with white background if needed
    if (addWhiteBackground) {
      cropProps.beforeCrop = (file) => addWhiteBackgroundToImage(file, aspect);
    }

    return (
      <ImgCrop {...cropProps}>
        {children}
      </ImgCrop>
    );
  }

  return children;
};

ImageCropWrapper.propTypes = {
  withCrop: PropTypes.bool,
  children: PropTypes.node.isRequired,
  aspect: PropTypes.number,
  addWhiteBackground: PropTypes.bool,
};

export default ImageCropWrapper;
